import { API_BASE_URL } from '../../../lib/api';

import { apiFetch } from '@/lib/apiFetch';
import { withTenant } from '../../../lib/tenantHeaders';

const JSON_HEADERS = withTenant({ 'Content-Type': 'application/json' });

export const fetchUsers = async ({ limit = 10, offset = 1, query = {} } = {}) => {
  const res = await apiFetch(`${API_BASE_URL}/users/filter`, {
    method: 'POST',
    headers: JSON_HEADERS,
    body: JSON.stringify({ limit, offset, query }),
  });
  return res.json();
};

export const createUser = async (data) => {
  const res = await apiFetch(`${API_BASE_URL}/users`, {
    method: 'POST',
    headers: JSON_HEADERS,
    body: JSON.stringify(data),
  });
  return res.json();
};

export const updateUser = async (id, data) => {
  const res = await apiFetch(`${API_BASE_URL}/users/${id}`, {
    method: 'PUT',
    headers: JSON_HEADERS,
    body: JSON.stringify(data),
  });
  return res.json();
};

export const deleteUser = async (id) => {
  const res = await apiFetch(`${API_BASE_URL}/users/${id}`, {
    method: 'DELETE',
    headers: withTenant(),
  });
  return res.json();
};

/**
 * Wrapper de fetchUsers pensado para ExportExcelButton.
 * Pide hasta 10.000 registros con el mismo set de filtros.
 */
export const exportUsers = async ({ query = {} } = {}) => {
  return fetchUsers({ limit: 10000, offset: 1, query });
};
